// A small Chinese-checkers star (hexagram) with the six home colours — used as
// the sidebar logo mark. Kept in sync with public/favicon.svg.
export default function StarBoard({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" aria-hidden="true">
      <path d="M50 10 L84.6 70 L15.4 70 Z" fill="#e7d4ab" stroke="#7a4a22" strokeWidth="3.2" strokeLinejoin="round" />
      <path d="M50 90 L15.4 30 L84.6 30 Z" fill="#e7d4ab" stroke="#7a4a22" strokeWidth="3.2" strokeLinejoin="round" />
      <circle cx="50" cy="18" r="6.6" fill="#1275ad" />
      <circle cx="77.7" cy="34" r="6.6" fill="#e0a12a" />
      <circle cx="77.7" cy="66" r="6.6" fill="#3f9d5a" />
      <circle cx="50" cy="82" r="6.6" fill="#c0202c" />
      <circle cx="22.3" cy="66" r="6.6" fill="#d9772e" />
      <circle cx="22.3" cy="34" r="6.6" fill="#8250b4" />
    </svg>
  )
}
